// src/components/admin/CreateDealerModal.js
import React, { useState } from 'react';
import { X } from 'lucide-react';
import './createdealermodal.css';

function CreateDealerModal({ 
  handleCreateUser, 
  setShowCreateDealerModal,
  newUsername, setNewUsername,
  newEmail, setNewEmail,
  newMobile, setNewMobile,
  newPassword, setNewPassword,
  currentUserRole
}) {
  const [uniqueId, setUniqueId] = useState('');
  const [speedUnit, setSpeedUnit] = useState('km/h');
  const [distanceUnit, setDistanceUnit] = useState('km');
  const [altitudeUnit, setAltitudeUnit] = useState('meters');
  const [volumeUnit, setVolumeUnit] = useState('Liter');
  const [timezone, setTimezone] = useState('Asia/Kolkata');
  
  // Dealer Permissions
  const [deviceAdd, setDeviceAdd] = useState(true);
  const [deviceEdit, setDeviceEdit] = useState(true);
  const [deviceDelete, setDeviceDelete] = useState(false);
  const [deviceRenew, setDeviceRenew] = useState(false);
  
  const [userAdd, setUserAdd] = useState(true);
  const [userEdit, setUserEdit] = useState(true);
  const [userDelete, setUserDelete] = useState(true);
  
  const [dealerAdd, setDealerAdd] = useState(true);
  const [dealerEdit, setDealerEdit] = useState(true);
  const [dealerDelete, setDealerDelete] = useState(true);
  
  const [notificationAdd, setNotificationAdd] = useState(true);
  const [notificationEdit, setNotificationEdit] = useState(true);
  
  const [dataPushAllow, setDataPushAllow] = useState(false);
  const [sensorsAllow, setSensorsAllow] = useState(false);
  const [summaryEdit, setSummaryEdit] = useState(false);
  const [noDeviceTextbox, setNoDeviceTextbox] = useState(false);
  
  const [deviceLimit, setDeviceLimit] = useState('0');
  const [userLimit, setUserLimit] = useState('5');
  
  const [disabled, setDisabled] = useState(false);
  const [limitCommands, setLimitCommands] = useState(false);
  const [readonly, setReadonly] = useState(false);
  const [disableReports, setDisableReports] = useState(false);
  const [deviceReadonly, setDeviceReadonly] = useState(false);
  const [stopParkingAlerts, setStopParkingAlerts] = useState(false);
  const [dontUseLicense, setDontUseLicense] = useState(false);

  const [attributes, setAttributes] = useState([]);

  const addAttribute = () => {
    setAttributes([...attributes, { name: '', type: 'text' }]);
  };

  const removeAttribute = (index) => {
    setAttributes(attributes.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const dealerData = {
      username: newUsername,
      email: newEmail,
      mobileNo: newMobile,
      password: newPassword,
      role: 'group_admin',
      uniqueId: uniqueId || undefined,
      speedUnit,
      distanceUnit,
      altitudeUnit,
      volumeUnit,
      timezone,
      devicePermissions: {
        create: deviceAdd,
        read: true,
        update: deviceEdit,
        delete: deviceDelete,
        command: !limitCommands
      },
      userPermissions: {
        create: userAdd,
        read: true,
        update: userEdit,
        delete: userDelete,
        assign: dealerAdd
      },
      deviceLimit: parseInt(deviceLimit) || 0,
      userLimit: parseInt(userLimit) || 5,
      isActive: !disabled,
      attributes: attributes.length > 0 ? attributes : undefined
    };
    
    handleCreateUser(e, dealerData);
  };

  return (
    <div className="um-modal-overlay">
      <div className="um-modal-content" style={{ maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="um-modal-header">
          <h3>Add Dealer</h3>
          <button type="button" className="um-close-icon" onClick={() => setShowCreateDealerModal(false)}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          {/* Required Section */}
          <div className="um-form-section">
            <h4 className="um-section-title">Required</h4>
            
            <div className="um-form-grid">
              <div className="um-form-group">
                <label>Name *</label>
                <input 
                  type="text" 
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>User ID *</label>
                <input 
                  type="text" 
                  value={uniqueId}
                  onChange={(e) => setUniqueId(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>Email *</label>
                <input 
                  type="email" 
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>Mobile</label>
                <input 
                  type="text" 
                  value={newMobile}
                  onChange={(e) => setNewMobile(e.target.value)}
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>Enter Password *</label>
                <input 
                  type="password" 
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required 
                  className="um-input"
                />
              </div>
            </div>
          </div>

          {/* Preferences Section */}
          <div className="um-form-section">
            <h4 className="um-section-title">Preferences</h4>
            
            <div className="um-form-grid">
              <div className="um-form-group">
                <label>Speed Unit</label>
                <select value={speedUnit} onChange={(e) => setSpeedUnit(e.target.value)} className="um-select-full">
                  <option value="km/h">km/h</option>
                  <option value="mph">mph</option>
                  <option value="knots">knots</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Distance Unit</label>
                <select value={distanceUnit} onChange={(e) => setDistanceUnit(e.target.value)} className="um-select-full">
                  <option value="km">km</option>
                  <option value="miles">miles</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Altitude Unit</label>
                <select value={altitudeUnit} onChange={(e) => setAltitudeUnit(e.target.value)} className="um-select-full">
                  <option value="meters">m</option>
                  <option value="feet">feet</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Volume Unit</label>
                <select value={volumeUnit} onChange={(e) => setVolumeUnit(e.target.value)} className="um-select-full">
                  <option value="Liter">Liter</option>
                  <option value="Gallon">Gallon</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Time Zone</label>
                <select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="um-select-full">
                  <option value="Asia/Kolkata">Asia/Kolkata</option>
                  <option value="UTC">UTC+0</option>
                </select>
              </div>

              <div className="um-form-group">
                <label>Language</label>
                <select className="um-select-full">
                  <option value="">Select</option>
                  <option value="en">English</option>
                </select>
              </div>
            </div>
          </div>

          {/* Permissions Section */}
          <div className="um-form-section">
            <h4 className="um-section-title">Permissions</h4>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px' }}>
              {/* Device Permission */}
              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>Device permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={deviceAdd} onChange={(e) => setDeviceAdd(e.target.checked)} />
                  <span>Add</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={deviceEdit} onChange={(e) => setDeviceEdit(e.target.checked)} />
                  <span>Edit</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={deviceDelete} onChange={(e) => setDeviceDelete(e.target.checked)} />
                  <span>Delete</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={deviceRenew} onChange={(e) => setDeviceRenew(e.target.checked)} />
                  <span>Renew</span>
                </label>
              </div>

              {/* User Permission */}
              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>User permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={userAdd} onChange={(e) => setUserAdd(e.target.checked)} />
                  <span>Add</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={userEdit} onChange={(e) => setUserEdit(e.target.checked)} />
                  <span>Edit</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={userDelete} onChange={(e) => setUserDelete(e.target.checked)} />
                  <span>Delete</span>
                </label>
              </div>

              {/* Dealer Permission */}
              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>Dealer permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={dealerAdd} onChange={(e) => setDealerAdd(e.target.checked)} />
                  <span>Add</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={dealerEdit} onChange={(e) => setDealerEdit(e.target.checked)} />
                  <span>Edit</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={dealerDelete} onChange={(e) => setDealerDelete(e.target.checked)} />
                  <span>Delete</span>
                </label>
              </div>

              {/* Notification Permission */}
              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>Notification permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={notificationAdd} onChange={(e) => setNotificationAdd(e.target.checked)} />
                  <span>Add</span>
                </label>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={notificationEdit} onChange={(e) => setNotificationEdit(e.target.checked)} />
                  <span>Edit</span>
                </label>
              </div>
            </div>

            {/* Additional Permissions */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', marginTop: '15px' }}>
              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>Data push permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={dataPushAllow} onChange={(e) => setDataPushAllow(e.target.checked)} />
                  <span>Allow</span>
                </label>
              </div>

              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>Sensors permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={sensorsAllow} onChange={(e) => setSensorsAllow(e.target.checked)} />
                  <span>Allow</span>
                </label>
              </div>

              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>Summary edit permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={summaryEdit} onChange={(e) => setSummaryEdit(e.target.checked)} />
                  <span>Allow</span>
                </label>
              </div>

              <div>
                <p style={{ fontWeight: '600', marginBottom: '8px' }}>No of device textbox permission</p>
                <label className="um-checkbox-label">
                  <input type="checkbox" checked={noDeviceTextbox} onChange={(e) => setNoDeviceTextbox(e.target.checked)} />
                  <span>Allow</span>
                </label>
              </div>
            </div>

            {/* Limits */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px', marginTop: '15px' }}>
              <div className="um-form-group">
                <label>Device Limit</label>
                <input 
                  type="number" 
                  value={deviceLimit}
                  onChange={(e) => setDeviceLimit(e.target.value)}
                  className="um-input"
                />
              </div>

              <div className="um-form-group">
                <label>User Limit</label>
                <input 
                  type="number" 
                  value={userLimit}
                  onChange={(e) => setUserLimit(e.target.value)}
                  className="um-input"
                />
              </div>
            </div>

            {/* Checkboxes Row */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginTop: '15px' }}>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={disabled} onChange={(e) => setDisabled(e.target.checked)} />
                <span>Disabled</span>
              </label>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={limitCommands} onChange={(e) => setLimitCommands(e.target.checked)} />
                <span>Limit Commands</span>
              </label>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={readonly} onChange={(e) => setReadonly(e.target.checked)} />
                <span>Readonly</span>
              </label>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={disableReports} onChange={(e) => setDisableReports(e.target.checked)} />
                <span>Disable Reports</span>
              </label>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={deviceReadonly} onChange={(e) => setDeviceReadonly(e.target.checked)} />
                <span>Device Readonly</span>
              </label>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={stopParkingAlerts} onChange={(e) => setStopParkingAlerts(e.target.checked)} />
                <span>Stop parking alerts</span>
              </label>
              <label className="um-checkbox-label">
                <input type="checkbox" checked={dontUseLicense} onChange={(e) => setDontUseLicense(e.target.checked)} />
                <span>Don't use dealer's license when device is assigned to dealer</span>
              </label>
            </div>
          </div>

          {/* Attributes Section */}
          <div className="um-form-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 className="um-section-title">Attributes</h4>
              <button type="button" className="um-btn-sm um-btn-secondary" onClick={addAttribute}>
                + ADD
              </button>
            </div>

            {attributes.map((attr, index) => (
              <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                <input 
                  type="text" 
                  placeholder="Attribute Name"
                  value={attr.name}
                  onChange={(e) => {
                    const newAttrs = [...attributes];
                    newAttrs[index].name = e.target.value;
                    setAttributes(newAttrs);
                  }}
                  className="um-input"
                  style={{ flex: 1 }}
                />
                <select 
                  value={attr.type}
                  onChange={(e) => {
                    const newAttrs = [...attributes];
                    newAttrs[index].type = e.target.value;
                    setAttributes(newAttrs);
                  }}
                  className="um-select-full"
                  style={{ flex: 1 }}
                >
                  <option value="text">text</option>
                  <option value="number">number</option>
                </select>
                <button 
                  type="button" 
                  className="um-btn-sm um-btn-delete"
                  onClick={() => removeAttribute(index)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          <div className="um-modal-actions">
            <button type="button" className="um-btn um-btn-secondary" onClick={() => setShowCreateDealerModal(false)}>
              CANCEL
            </button>
            <button type="submit" className="um-btn um-btn-primary">
              SAVE
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateDealerModal;